import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class UsageReport extends Model<Schemas['usageReports'], Models> {
    get toDate() {
        return nullableDate(this.to);
    }

    get fromDate() {
        return nullableDate(this.from);
    }
}
